import React, { HtmlHTMLAttributes } from 'react';

import { Icon } from '../Icon';
import {
  ActionsRow,
  AddButton,
  Container,
  ContainerContent,
  ContainerImg,
  DetailsButton,
  LibraryTag,
  RemoveButton,
  Subtitle,
  Tag,
  Title,
  VideoBadge,
} from './styles';

import noMidia from '../../assets/no-midia.svg';
import { IExerciseMuscleGroup } from '../../domains/Exercise';

interface CardExerciseProps extends HtmlHTMLAttributes<HTMLDivElement> {
  exerciseName: string;
  muscleGroups: IExerciseMuscleGroup[];
  description?: string;
  disableOptHover?: boolean;
  compact?: boolean;
  isCustom?: boolean;
  functionChangeButton?: any;
  changeButtonLabel?: string;
  functionRemoveButton?: any;
  functionQuickAddButton?: any;
  quickAddLoading?: boolean;
  id?: string;
  thumbnail_url?: string | undefined;
  hasVideo?: boolean;
}

const CardExercise: React.FC<CardExerciseProps> = ({
  exerciseName,
  muscleGroups,
  description,
  id,
  thumbnail_url,
  hasVideo,
  compact,
  isCustom,
  functionChangeButton,
  changeButtonLabel,
  functionRemoveButton,
  functionQuickAddButton,
  quickAddLoading,
  ...rest
}) => {
  const sortedGroups = [...(muscleGroups || [])].sort((a, b) =>
    a.is_main ? -1 : b.is_main ? 1 : 0,
  );

  const mainGroup =
    sortedGroups[0]?.muscle_group?.name || sortedGroups[0]?.name;
  const otherGroups = sortedGroups
    .slice(1)
    .map(group => group.muscle_group?.name || group.name)
    .filter(Boolean)
    .join(', ');

  return (
    <Container {...rest}>
      <ContainerImg compact={compact}>
        <img src={thumbnail_url || noMidia} alt="midia exercise" />
        {!!mainGroup && <Tag>{mainGroup}</Tag>}
        {isCustom === false && <LibraryTag>Padrão</LibraryTag>}
        {hasVideo && (
          <VideoBadge>
            <Icon name="play_arrow" size={16} color="currentColor" />
          </VideoBadge>
        )}
      </ContainerImg>
      <ContainerContent compact={compact}>
        <Title>{exerciseName}</Title>
        <Subtitle>{description || otherGroups || ' '}</Subtitle>

        <ActionsRow>
          <DetailsButton type="button" onClick={functionChangeButton}>
            {changeButtonLabel || 'Detalhes'}
          </DetailsButton>

          {!!functionQuickAddButton && (
            <AddButton
              type="button"
              onClick={functionQuickAddButton}
              disabled={quickAddLoading}
            >
              <Icon name="add" size={18} color="currentColor" />
              {quickAddLoading ? 'Adicionando...' : 'Adicionar'}
            </AddButton>
          )}

          {!!functionRemoveButton && (
            <RemoveButton type="button" onClick={functionRemoveButton}>
              <Icon name="delete" size={18} color="currentColor" />
            </RemoveButton>
          )}
        </ActionsRow>
      </ContainerContent>
    </Container>
  );
};

export { CardExercise };
